import useHttpPost from "./useHttpPost";


export function usePostFitter(target) {
  return useHttpPost("createfitter", "post", {}, target);
}
